import { type HTMLAttributes } from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../../lib/cn'

const badgeVariants = cva(
  'inline-flex items-center px-[10px] py-[3px] rounded-full font-sans text-xs font-medium',
  {
    variants: {
      variant: {
        accent:  'bg-accent-muted text-accent',
        violet:  'bg-violet-muted text-violet',
        sage:    'bg-sage-muted text-sage',
        success: 'bg-success-muted text-success',
        warning: 'bg-warning-muted text-warning',
        error:   'bg-error-muted text-error',
      },
    },
    defaultVariants: {
      variant: 'accent',
    },
  }
)

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
